function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, memo } from 'react';
import styled from 'styled-components';
import { string, bool, oneOf, shape } from 'prop-types';
import equals from 'ramda/src/equals';
import { GEL_SPACING_DBL, GEL_SPACING_QUAD, GEL_SPACING_TRPL } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_4_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import Placeholder from './Placeholder';
import Amp from './Amp';
import Canonical from './Canonical';
import Message from './Message';
var landscapeRatio = '56.25%'; // (9/16)*100 = 16:9

var portraitRatio = '177.78%'; // (16/9)*100 = 9:16

var StyledVideoContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledVideoContainer",
  componentId: "sc-13p1a4d-0"
})(["padding-top:", ";position:relative;overflow:hidden;margin-bottom:", ";@media (min-width:", "){margin-bottom:", ";}"], function (_ref) {
  var portrait = _ref.portrait;
  return portrait ? portraitRatio : landscapeRatio;
}, GEL_SPACING_DBL, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_SPACING_TRPL);
var StyledAudioContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAudioContainer",
  componentId: "sc-13p1a4d-1"
})(["height:165px;position:relative;margin-bottom:", ";@media (min-width:", "){margin-bottom:", ";}"], GEL_SPACING_DBL, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_SPACING_QUAD);

var CanonicalMediaPlayerComponent = function CanonicalMediaPlayerComponent(_ref2) {
  var showPlaceholder = _ref2.showPlaceholder,
      placeholderSrc = _ref2.placeholderSrc,
      placeholderSrcset = _ref2.placeholderSrcset,
      portrait = _ref2.portrait,
      src = _ref2.src,
      title = _ref2.title,
      skin = _ref2.skin,
      service = _ref2.service,
      mediaInfo = _ref2.mediaInfo,
      noJsClassName = _ref2.noJsClassName,
      noJsMessage = _ref2.noJsMessage;

  var _useState = useState(showPlaceholder),
      _useState2 = _slicedToArray(_useState, 2),
      placeholderActive = _useState2[0],
      setPlaceholderActive = _useState2[1];

  var handlePlaceholderClick = function handlePlaceholderClick() {
    return setPlaceholderActive(false);
  };

  var StyledContainer = skin === 'audio' ? StyledAudioContainer : StyledVideoContainer;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    portrait: portrait
  }, placeholderActive ? /*#__PURE__*/React.createElement(Placeholder, {
    onClick: handlePlaceholderClick,
    src: placeholderSrc,
    srcset: placeholderSrcset,
    service: service,
    mediaInfo: mediaInfo,
    noJsClassName: noJsClassName,
    noJsMessage: noJsMessage
  }) : /*#__PURE__*/React.createElement(Canonical, {
    src: src,
    placeholderSrcset: placeholderSrcset,
    showPlaceholder: showPlaceholder,
    title: title,
    placeholderSrc: placeholderSrc,
    service: service,
    noJsMessage: noJsMessage
  }));
}; // Component receives a "mediaInfo" object prop - this can cause unnecessary
// re-renders when the object reference changes, but the content is the same.
// We only rerender if the prevProps and nextProps fail deep equality check


export var CanonicalMediaPlayer = /*#__PURE__*/memo(CanonicalMediaPlayerComponent, equals);
export var AmpMediaPlayer = function AmpMediaPlayer(_ref3) {
  var placeholderSrcset = _ref3.placeholderSrcset,
      placeholderSrc = _ref3.placeholderSrc,
      portrait = _ref3.portrait,
      src = _ref3.src,
      title = _ref3.title,
      skin = _ref3.skin,
      noJsMessage = _ref3.noJsMessage,
      service = _ref3.service;
  var StyledContainer = skin === 'audio' ? StyledAudioContainer : StyledVideoContainer;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    portrait: portrait
  }, /*#__PURE__*/React.createElement(Amp, {
    placeholderSrcset: placeholderSrcset,
    placeholderSrc: placeholderSrc,
    src: src,
    title: title,
    height: portrait ? 9 : 16,
    width: portrait ? 16 : 9,
    noJsMessage: noJsMessage,
    service: service
  }));
};
export var MediaMessage = Message;
CanonicalMediaPlayerComponent.propTypes = {
  placeholderSrc: string,
  placeholderSrcset: string,
  portrait: bool,
  showPlaceholder: bool,
  src: string.isRequired,
  title: string.isRequired,
  skin: oneOf(['classic', 'audio']),
  service: string.isRequired,
  noJsClassName: string,
  noJsMessage: string.isRequired,
  mediaInfo: shape({
    title: string,
    datetime: string,
    duration: string,
    durationSpoken: string,
    type: oneOf(['video', 'audio']),
    guidanceMessage: string
  })
};
CanonicalMediaPlayerComponent.defaultProps = {
  portrait: false,
  showPlaceholder: true,
  skin: 'classic',
  placeholderSrc: null,
  placeholderSrcset: null,
  noJsClassName: null,
  mediaInfo: {}
};
MediaMessage.propTypes = {
  service: string.isRequired,
  message: string.isRequired,
  placeholderSrc: string,
  placeholderSrcset: string
};
MediaMessage.defaultProps = {
  placeholderSrc: null,
  placeholderSrcset: null
};
AmpMediaPlayer.propTypes = {
  placeholderSrc: string.isRequired,
  placeholderSrcset: string,
  portrait: bool,
  src: string.isRequired,
  title: string.isRequired,
  skin: oneOf(['classic', 'audio']),
  noJsMessage: string.isRequired,
  service: string.isRequired
};
AmpMediaPlayer.defaultProps = {
  portrait: false,
  skin: 'classic',
  placeholderSrcset: null
};